import React, { useMemo } from 'react';
import { Table as AntdTable, Modal, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { CSVLink } from 'react-csv';
import ActionTypes from '@utils/deviceActions';
import useSwr from '@hooks/useSwr';

const ReactCSVLink = CSVLink as unknown as React.FC<any>;

type DevicesModalProps = {
  operationId?: string;
  visible: boolean;
  onClose: () => void;
  operationType?: string;
};

const DevicesModal = ({
  operationId,
  visible,
  onClose,
  operationType,
}: DevicesModalProps) => {
  const { t } = useTranslation('operational');
  const { t: tDevices } = useTranslation('device-actions');

  const { data } = useSwr(
    visible ? `/service-proxy/broker/operations/${operationId}/devices` : null,
  );

  const actionsNumber = [
    {
      number: ActionTypes.ALLOWANCE_PLAN_RENEWAL,
      name: 'allowance_plan_renewal',
    },
    {
      number: ActionTypes.BAIT_RENEWAL,
      name: 'bait_renewal',
    },
    {
      number: ActionTypes.BROKER_CANCELLATION,
      name: 'cancellation',
    },
    {
      number: ActionTypes.BROKER_SUBSTITUTION,
      name: 'substitution',
    },
    {
      number: ActionTypes.SUSPENSION,
      name: 'suspension',
    },
    {
      number: ActionTypes.WITHDRAWAL_OF_SUSPENSION,
      name: 'suspension_reverse',
    },
  ];

  const findNumber = actionsNumber.find(
    item => item.name === operationType?.toLowerCase(),
  )?.number;

  const devicesColumns = useMemo(
    () => [
      {
        title: 'MSISDN',
        dataIndex: 'msisdn',
        ellipsis: false,
        width: 120,
      },
      {
        title: 'ICCID',
        dataIndex: 'iccd',
        ellipsis: false,
        width: 120,
      },
      {
        title: t('table.status'),
        dataIndex: 'status',
        ellipsis: false,
        width: 150,
        render: (status: string) => tDevices(`status.${findNumber}.${status}`),
      },
    ],
    [t, tDevices, findNumber],
  );

  const csvHeaders = [
    { label: 'MSISDN', key: 'msisdn' },
    { label: 'ICCID', key: 'iccd' },
    { label: `${t('table.status')}`, key: 'status' },
  ];

  return (
    <>
      <Modal
        bodyStyle={{ padding: 24 }}
        footer={false}
        open={visible}
        centered
        title="Simcards"
        onCancel={onClose}
      >
        <div style={{ display: 'flex', justifyContent: 'end' }}>
          <Button type="primary" style={{ marginBottom: 16 }}>
            <ReactCSVLink
              data={
                data?.map((item: any) => {
                  return {
                    msisdn: item.msisdn,
                    iccd: item.iccd,
                    status: tDevices(`status.${findNumber}.${item.status}`),
                  };
                }) || []
              }
              headers={csvHeaders}
              filename={`simcards_${operationId}.xlsx`}
            >
              {t('export')}
            </ReactCSVLink>
          </Button>
        </div>
        <AntdTable
          dataSource={data || []}
          columns={devicesColumns}
          loading={!data}
          pagination={false}
          style={{
            width: '100%',
            minWidth: '400px',
          }}
          scroll={{ x: 'max-content' }}
          size="middle"
        />
      </Modal>
    </>
  );
};

export default DevicesModal;
